var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTikTok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M15.058 4h-2.565v10.899c0 1.298-.986 2.365-2.214 2.365s-2.214-1.067-2.214-2.365c0-1.276.965-2.32 2.148-2.366V9.797C7.605 9.843 5.5 12.093 5.5 14.898 5.5 17.729 7.648 20 10.301 20s4.801-2.296 4.801-5.101V9.31a5.752 5.752 0 003.398 1.206V7.78c-1.93-.07-3.442-1.74-3.442-3.78z"
  }));
}
export default SvgIconTikTok;